import { EMPTY_VALUE, SETTING_UNITS_KEY } from '@src/core/config';
import { UnitType } from '@src/core/enums';
import { arcToFixed } from "./arc-to-fixed";

export const arcSpatiumConvert = (value?: number | null | string) => {

  const payload = Number(value);
  
  const type = localStorage.getItem(SETTING_UNITS_KEY);

  if (isNaN(payload)) return EMPTY_VALUE;

  if (type === UnitType.SI) return Number(arcToFixed(payload));

  if (type === UnitType.IMPERIAL) return Number(arcToFixed(payload * 3.28084));

  return EMPTY_VALUE;
};